<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Custom Clearance B/L</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                v-if="BLRaised.ccBlId!=''"
                variant="success"
                size="sm"
                id="addButtonLoader"
                @click="downloadWord(BLRaised.ccBlId)"
              >Download Word</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.mainEntryData[0].allModuleId ? this.mainEntryData[0].allModuleId : ''"
          :jobSeriesBanner="this.mainEntryData[0].ccImportSeries ? this.mainEntryData[0].ccImportSeries : ''"
          :bannerClientName="this.mainEntryData[0].exporterName ? this.mainEntryData[0].exporterName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <b-card style="height:90px !important" class="HeaderMastBanner">
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Assignment No. : {{mainEntryData[0].ccImportSeries}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>Job Type : {{mainEntryData[0].jobType}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>Importer Name : {{mainEntryData[0].importerName}}</b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25">
                  <b>FF Activity : {{mainEntryData[0].containerInfo}}</b>
                </md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <b>
                      Exporter Name : {{mainEntryData[0].exporterName}}
                      <br>
                    </b>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="25"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100"></md-layout>
                </md-layout>
              </md-layout>
            </b-card> -->
            <div>
              <md-layout md-gutter class="labelMargtop">
               

                <md-layout md-flex="45">
                  <label for="blType">B/L Stage</label>
                  <model-list-select
                    :list="blStageList"
                    v-model="BLRaised.blStage"
                    option-value="blStageVal"
                    option-text="blStageTxt"
                    placeholder="Select B/L Stage"
                  ></model-list-select>
                  <span class="error" v-if="!BLRaised.blStage">{{errorBLRaised.blStage}}</span>
                </md-layout>
              </md-layout>
              <md-layout gutter style="margin-top:2%">
              
                <md-layout md-flex="35">
                  <label>CONSIGNOR</label>
                </md-layout>
   <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="50">
                  <label>CONSIGNEE ( OR ORDER)</label>
                </md-layout>
              </md-layout>
              <md-layout gutter>
             
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <quill-editor
                    style="width:100% !important"
                      ref="myTextEditor"
                      v-model="BLRaised.consignor"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.consignor">{{errorBLRaised.consignor}}</span>
                </md-layout>
  <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <quill-editor
                     style="width:100% !important"
                      ref="myTextEditor"
                      v-model="BLRaised.consignee"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.consignee">{{errorBLRaised.consignee}}</span>
                </md-layout>
              </md-layout>
              <md-layout gutter>
                <md-layout
                  md-flex="30"
                  v-for="(singleInput, index) in BLRaised.notifyList"
                  :key="index"
                  class="gutr"
                >
                  <md-layout md-flex="100">
                  
                    <md-layout md-flex="60">
                      <label>{{ notifyArray[index] }} Notify Party</label>
                    </md-layout>
                    <md-layout md-flex="5" ></md-layout>
                    <md-layout md-flex="10" v-if="index>1">
                         <md-button
                     class="md-icon-button md-raised md-dense"
                        @click="removeNotify(index)"
                        style="min-height:20px;height:20px;margin-top:25px"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                     
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="100">
              
                    <md-layout md-flex="90">
                      <quill-editor class="mt-2"  ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout gutter class="gutr">
              
                <md-layout md-flex="30">
                 <b-button size="sm" variant="outline-dark" @click="addNotify">Add More Notify</b-button>
                  <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
              
                <md-layout md-flex="25">
                  <label>Place of Acceptance/Date</label>

                  <date-picker
                    v-model="BLRaised.acceptanceDate"
                    lang="en"
                    type="datetime"
                    format="YYYY-MM-DD hh:mm "
                    :minute-step="1"
                    id="acceptanceDate"
                  ></date-picker>
                  <span
                    class="error"
                    v-if="!BLRaised.acceptanceDate"
                  >{{errorBLRaised.acceptanceDate}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="70">
                  <md-layout md-flex="100">
                    <label>Vessel/Voy</label>
                    <b-form-input :formatter="capitalizeAll" id="vesselVoy" name="vesselVoy" v-model="BLRaised.vesselVoy"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.vesselVoy">{{errorBLRaised.vesselVoy}}</span>
                </md-layout>
              </md-layout>

              <md-layout gutter class="gutr">
          
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Place of Receipt</label>
                    <b-form-input :formatter="capitalizeAll" id="portLoad" name="portLoad" v-model="BLRaised.POR"></b-form-input>
                  </md-layout>
                </md-layout>
                  <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Port of Loading</label>
                    <b-form-input :formatter="capitalizeAll" id="portLoad" name="portLoad" v-model="BLRaised.portLoad"></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.portLoad">{{errorBLRaised.portLoad}}</span>
                </md-layout>
              </md-layout>

              <md-layout gutter class="gutr">
              
             
                <md-layout md-flex="45">
                  <md-layout md-flex="100">
                    <label>Port of Discharge</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="portDischarge"
                      name="portDischarge"
                      v-model="BLRaised.portDischarge"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.portDischarge">{{errorBLRaised.portDischarge}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <md-layout md-flex="100">
                    <label>Place of Delivery</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="placeDilievery"
                      name="placeDilievery"
                      v-model="BLRaised.placeDilievery"
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!BLRaised.placeDilievery"
                  >{{errorBLRaised.placeDilievery}}</span>
                  <!--  -->
                </md-layout>
              </md-layout>
              <md-layout gutter class="gutr">
             
                <md-layout md-flex="40">
                  <label>Container No. / Marks and Nos</label>
                </md-layout>
                <md-layout md-flex="35">
                  <label>Description of Packages and Goods</label>
                </md-layout>
                <md-layout md-flex="20">
                  <label>No. of Pkgs</label>
                </md-layout>
              </md-layout>
              <md-layout gutter>
            
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <quill-editor
                    style=" width: 100% !important;"
                      ref="myTextEditor"
                      v-model="BLRaised.containerMarks"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!BLRaised.containerMarks"
                  >{{errorBLRaised.containerMarks}}</span>
                </md-layout>
                 <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <quill-editor
                      ref="myTextEditor"
                   style=" width: 100% !important;"
                      v-model="BLRaised.descriptionGood"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!BLRaised.descriptionGood"
                  >{{errorBLRaised.descriptionGood}}</span>
                </md-layout>
                 <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <quill-editor
                    style=" width: 100% !important;"
                      ref="myTextEditor"
                      v-model="BLRaised.noPkg"
                      :options="editorOption"
                    ></quill-editor>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.noPkg">{{errorBLRaised.noPkg}}</span>
                </md-layout>
              </md-layout>

              <md-layout gutter style="margin-top:2%">
                
                <md-layout md-flex="40">
                  <label>Gross Weight</label>
                </md-layout>

                <md-layout md-flex="35">
                  <label>Net Weight</label>
                </md-layout>
              </md-layout>
              <md-layout gutter>
           
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <quill-editor    style=" width: 100% !important;" v-model="BLRaised.grossWeight" :options="editorOption"></quill-editor>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.grossWeight">{{errorBLRaised.grossWeight}}</span>
                </md-layout>
                     <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <quill-editor    style=" width: 100% !important;" v-model="BLRaised.netWeight" :options="editorOption"></quill-editor>
                  </md-layout>
                  <span class="error" v-if="!BLRaised.netWeight">{{errorBLRaised.netWeight}}</span>
                </md-layout>
              </md-layout>
              <md-layout gutter class="gutr">
               
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Total Weight</label>
                    <b-form-input :formatter="capitalizeAll" id="portLoad" name="portLoad" v-model="BLRaised.totalWeight"></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Freight</label>
                    <b-form-input :formatter="capitalizeAll" id="portLoad" name="portLoad" v-model="BLRaised.freight"></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <div class="gutr">
                <b-button
                  variant="primary"
                  class="mt-3"
                  id="addButtonLoader"
                  @click="addBLRaised"
                >Save & Submit</b-button>
                <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
              </div>
              <div class="col-md-5"></div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (globalPermissionStatus("Custom Clearance")) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCExportEntry");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: false,
      content: `<h2 class="ql-align-center"><span class="ql-font-serif">sajnsajknsakjnask content loading..</span></h2>`,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      containerNoName: [],
      BLRaised: {
        freight: "",
        totalWeight: "",
        POR: "",
        ccBlId: "",
        uploadBL: "",
        blStage: "Draft",
        consignor: "",
        consignee: "",

        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],

        acceptanceDate: "",

        vesselVoy: "",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        containerMarks: "",
        noPkg: "",
        descriptionGood: "",
        grossWeight: "",
        netWeight: "",

        portLocationType: "NON_USA",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId")
      },

      errorBLRaised: {
        blStage: "",
        consignor: "",
        consignee: "",

        acceptanceDate: "",

        vesselVoy: "",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        containerMarks: "",
        noPkg: "",
        descriptionGood: "",
        grossWeight: "",
        netWeight: ""
      },

      arrayErrorBLRaised: [
        {
          blStage: "Please Select BL Stage",
          consignor: "Please Enter Consignor",
          consignee: "Please Enter Consignee",

          acceptanceDate: "Select Acceptance Date",

          vesselVoy: "Please Enter Vessel Voy",
          portLoad: "Please Enter Port Load",
          portDischarge: "Please Enter Port Discharge",
          placeDilievery: "Please Enter Place Delievery",
          containerMarks: "Please Enter Container Marks",
          noPkg: "Please Enter No of Package",
          descriptionGood: "Please Enter Description Good",
          grossWeight: "Please Enter Gross Weight",
          netWeight: "Please Enter Net Weight"
        }
      ],

      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],

      blStageList: [
        {
          blStageVal: "Draft",
          blStageTxt: "Draft"
        }
      ],

      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],

      PlaceList: [
        {
          PlaceVal: "Delhi",
          PlaceTxt: "Delhi"
        },
        {
          PlaceVal: "Jaipur",
          PlaceTxt: "Jaipur"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      AgentList: [],
      mainEntryData: [{allModuleId:null}],
      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    vgmModel: {
      handler: function(newVal, oldVal) {},
      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    BannerComponent,
  },

  computed: {},

  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print() {
      window.open(`${this.docURL}/BL/` + this.BLRaised.uploadBL);
    },
    downloadWord(id) {
      window.location = `${URL_BASE}/Api_Custom/wordBLCCEx.php?id=` + id;
    },
    validateBLRaised() {
      let validate_new = true;
      Object.keys(this.errorBLRaised).map((x, index) => {
        if (this.BLRaised[x] == "") {
          this.errorBLRaised[x] = this.arrayErrorBLRaised[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.BLRaised.notifyList.length]
      };
      this.BLRaised.notifyList.push(obj);
    },
    removeNotify(index) {
      this.BLRaised.notifyList.splice(index, 1);
    },

    addBLRaised() {
      this.BLRaised["ccImportId"] = this.$sessionsStorage.get("editCcImportId");

      this.validateBLRaised();

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addBLCCEx.php`,
          data: JSON.stringify(this.BLRaised),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.BLRaised.ccBlId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }
              this.$refs["addPop"].open();

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/fetchCCExBL.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            
            if (data.exportEntryData.length > 0) {
              this.mainEntryData = data.exportEntryData;
            }
            if (data.BLData.length > 0) {
              this.BLRaised.notifyList = [];
              Object.keys(this.BLRaised).map(x => {
                if (x == "notifyList") {
                  data.BLData[0][x].split("$$$").map((y, index) => {
                    let obj = {
                      inputValue: y,
                      text: this.notifyListArray[index]
                    };

                    this.BLRaised.notifyList.push(obj);
                  });
                } else {
                  this.BLRaised[x] = data.BLData[0][x] || "";
                }
              });
            } else {
              this.BLRaised.consignor =
                "<p>" +
                data.exportEntryData[0].exporterName +
                "</p><p>" +
                data.exportEntryData[0].ConsignerAddrs +
                "</p>";
              this.BLRaised.consignee =
                "<p>" +
                data.exportEntryData[0].importerName +
                "</p><p>" +
                data.exportEntryData[0].ConsigneeAddrs +
                "</p>";

              this.BLRaised.portLoad = data.exportEntryData[0].LoadPort;
              this.BLRaised.POR = data.exportEntryData[0].POR;
              this.BLRaised.portDischarge =
                data.exportEntryData[0].DischargePort;
              this.BLRaised.placeDilievery = data.exportEntryData[0].FinalPlace;
              this.BLRaised.noPkg = data.exportEntryData[0].noOfPackage;
            }
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/CCImport/ediExecution"
      // });
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ccExBL.vue?06794caa